module.exports = __webpack_public_path__ + "img/mattaka.3ed49cb7.png";